/**
 * THE CONFIGURATION, READ ON FIRST USE — never at import.
 *
 * ⚠️ THIS HAS BITTEN TWICE, and the second time it reached continuous
 * integration. Reading the configuration HALTS startup when a variable is
 * missing, which is exactly the point. But as a module-level constant that effect
 * fired for anyone who so much as imported this file — and a unit test importing
 * `api/client.ts`, which needs the API address only when it actually calls
 * something, brought the whole suite down on a machine with no `.env`.
 *
 * The first fix split the pure logic (`./env`) from its instantiation. It was not
 * enough: the instantiation still ran on import. So it is now DEFERRED to the
 * first read. Importing this module does nothing; ASKING it for the address is
 * what checks the address exists.
 *
 * Memoised, so the check still happens exactly once per session and a missing
 * variable still stops the application dead the first time it is needed.
 */
import { readConfig, type Config } from "./env";

export type { Config } from "./env";
export { MissingConfig, readConfig } from "./env";

let cached: Config | null = null;

export function getConfig(): Config {
  cached ??= readConfig(
    import.meta.env as unknown as Record<string, string | undefined>,
  );
  return cached;
}
